import { Stack } from '@common/ui'
import { com } from '@eidu/web'
import EntityFormDisplay from '../../../../components/data/EntityFormDisplay'
import DraftFieldValue from '../../../../domain/entity/DraftFieldValue'
import FieldId = com.eidu.entity.field.FieldId
import EntityType = com.eidu.entity.type.EntityType

type EntityFieldDisplayGroupProps = {
  entityType: EntityType
  fields: ReadonlyMap<FieldId, DraftFieldValue>
}

const EntityFieldDisplayGroup = ({ entityType, fields }: EntityFieldDisplayGroupProps) => (
  <Stack gap="lg">
    {entityType.fields.asJsReadonlyArrayView().map((field) => (
      <EntityFormDisplay
        key={`entity-form-field-${field.id.toString()}`}
        field={field}
        fieldValue={fields.get(field.id)}
      />
    ))}
  </Stack>
)

export default EntityFieldDisplayGroup
